<template>
  <div>
    <h2>Scans by Month</h2>
    <apexchart
      type="line"
      :options="chartOptions"
      :series="chartSeries"
      height="250"
    ></apexchart>
  </div>
</template>

<script>
export default {
  name: 'LineChart',
  data() {
    return {
      chartOptions: {
        chart: {
          theme: 'dark',
          toolbar: {
            show: false
          },
          background: '#2d2d2d',
        },
        dataLabels: {
          style: {
            colors: ['#FFF']
          }
        },
        colors: ['#4fc3f7', '#e84118', '#f7b731', '#6610f2', '#1abc9c'],
        xaxis: {
          categories: this.getMonthLabels(),
          labels: {
            style: {
              colors: '#fff'
            }
          }
        },
        yaxis: {
          labels: {
            style: {
              colors: '#fff'
            }
          }
        },
        grid: {
          borderColor: '#444'
        },
        tooltip: {
          theme: 'dark',
          style: {
            backgroundColor: '#333'
          }
        },
        legend: {
          labels: {
            colors: '#fff'
          }
        }
      }
    };
  },
  computed: {
    chartSeries() {
      if (!this.selectedApps || this.selectedApps.length === 0) {
        return [];
      }
      const appCounts = this.getAppCountsByMonth(this.bqData, this.selectedApps);
      return this.formatDataForChart(appCounts, this.selectedApps);
    }
  },
  methods: {
    getMonthLabels() {
      const months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
      ];
      return months;
    },
    getAppCountsByMonth(data, selectedApps) {
      const appCounts = selectedApps.reduce((acc, app) => {
        acc[app] = Array(12).fill(0);
        return acc;
      }, {});

      data.forEach(item => {
        const { year, month, app_name, total_usage } = item;
        if (selectedApps.includes(app_name) && year === new Date().getFullYear()) {
          appCounts[app_name][month - 1] += total_usage;
        }
      });

      return appCounts;
    },
    formatDataForChart(appCounts, apps) {
      return apps.map(app => ({
        name: app,
        data: appCounts[app] || []
      }));
    }
  },
  props: {
    bqData: {
      type: Array,
      required: true
    },
    selectedApps: {
      type: Array,
      required: true
    }
  }
};
</script>